import call from './index'

//获取来源列表
export const supplyChannel = data => {
	return call('admin/supply_channel/search', data, 'get')
}

export const getSuppliers = data => {
	return call('admin/supplier/search', data)
}

export const checkGarunAtio = data => {
	return call('admin/product/check_garun_atio', data)
}

//创建编辑商品来源
export const supplyChannelUpdate = data => {
	return call('admin/supply_channel/update', data)
}
//删除商品来源
export const supplyChannelDelete = (id, data) => {
	return call(`admin/supply_channel/${id}/delete`, data)
}

//商品分类列表
export const productCategoryGet = data => {
	return call('/admin/product_categories/get', data, 'get')
}

// 1688分类列表
export const aliCateByLocal = data => {
	return call('admin/ali_product_cate/get', data, 'get')
}

//新增商品分类
export const insertProductCate = data => {
	return call('admin/product_cate/insert', data)
}
//修改分类排序
export const updateProductCateSort = (id, data) => {
	return call(`admin/product_cate/${id}/sort/update`, data)
}
//禁用和启用分类
export const updateCateStatus = (id, data) => {
	return call(`admin/product_cate/${id}/status/update`, data)
}

//批量删除分类
export const deleteProductCategories = data => {
	return call(`admin/product_categories/batch/delete`, data)
}

//分类详情
export const categoriesDetail = id => {
	return call(`/admin/product_cate/${id}/get`, null, 'get')
}

//编辑分类
export const updateProductCate = (id, data) => {
	return call(`/admin/product_cate/${id}/update`, data)
}

//供应链商品列表
export const productList = data => {
	return call(`/admin/product/search`, data, 'get')
}

//修改商品名称
export function updateProductTitle(id, data) {
	return call(`admin/product/${id}/title/update`, data)
}
//获取 供货价默认加润设置
export const getSupplyPrice = () => {
	return call('admin/setting/supply_product_add_profit/get', null, 'get')
}
//设置 供货价默认加润设置
export const setSupplyPrice = data => {
	return call('admin/setting/supply_product_add_profit/update', data)
}
//获取 在售价默认加润设置
export const getOnSalePrice = () => {
	return call('admin/setting/default_sale_profit/get', null, 'get')
}
//设置 在售价默认加润设置
export const setOnSalePrice = data => {
	return call('admin/setting/default_sale_profit/update', data)
}
//添加商品
export const createGoods = data => {
	return call('admin/product/add', data)
}
//编辑商品
export const updateGoods = data => {
	return call('admin/product/edit', data)
}
//商品详情
export const getGoodsInfo = id => {
	return call(`admin/product/${id}/get`, null, 'get')
}
//商品批量上架
export function putOnProcut(ids) {
	return call(`/admin/product/put_on_sale/update`, { ids: ids })
}

//商品批量下架
export function pullOffProduct(ids) {
	return call(`/admin/product/pull_off_shelves/update`, { ids: ids })
}
//编辑是否推荐
export function updateRecommend(id, data) {
	return call(`/admin/product/${id}/is_recommend/update`, data)
}

//删除商品
export function deleteProducts(data) {
	return call(`/admin/products/delete`, data)
}

//查看商品Sku
export function skusProduct(id, data) {
	return call(`/admin/product/${id}/sku/get`, data, 'get')
}

//商品详情
//采购下单

export function purchaseOrder(data) {
	return call(`admin/order/create/purchase`, data)
}

//省、市、区
export function regionWithPid(data) {
	return call(`admin/region`, data)
}

//结算
export const settlementPost = data => {
	return call('admin/supply_channel/settlement', data)
}
/******  运费模版  *******/
//模版列表
export function freightTemplateList(data) {
	return call('/admin/freight/freight_templates/list?', data, 'get')
}

//运费模版创建
export function freightTemplateAdd(data) {
	return call('/admin/freight/template/add', data)
}

//行政区域分组列表
export function freightRegionGroups() {
	return call('/admin/region/groups')
}

// //删除模版
// export function delFreighttemplate(id) {
// 	return call('/admin/freight/freight_template/' + id + '/delete')
// }

//模版详情
export function freightTemplateDetailData(data) {
	return call('/admin/freight/template/detail', data)
}


//模版编辑
export function freightTemplateEdit(data) {
	return call('/admin/freight/template/edit', data)
}

/*********  供应链商品库新增/编辑   运费模版  **********/ 
//模版编辑
export function freightTemplateShow(data) {
	return call(`/admin/product/freight`, data)
}

export function getClass(data) {
	return call(`/admin/product/get_class`, data)
}

export function classification(data) {
	return call(`/admin/product/classification`, data)
}